import LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';

// Our own testers: their sessions are never recorded, so the LogRocket quota and the
// usage statistics only cover real customers
const internalEmailPattern = /@(clickon\.ch|eventor\.app)$/i;

let recording = false;
let blocked = false;

export function isInternalEmail(email) {
  return typeof email === 'string' && internalEmailPattern.test(email.trim());
}

/**
 * Starts recording unless this is one of our own accounts. Firebase reports the signed-in user
 * (or null) a moment after the app boots, which is why recording does not start in main.js.
 */
export function startLogRocket(email) {
  if (process.env.NODE_ENV !== 'production' || recording || blocked) return;

  if (isInternalEmail(email)) {
    blocked = true;

    return;
  }

  recording = true;

  LogRocket.init(`3iqapi/eventor-${process.env.VUE_APP_MODE}`);
  LogRocket.info(`Eventor v${process.env.VUE_APP_VERSION}`);

  Sentry.configureScope((scope) => {
    LogRocket.getSessionURL((sessionURL) => {
      scope.setExtra('LogRocket session URL', sessionURL);
    });
  });
}

/**
 * Signing in with one of our own addresses after an anonymous session has started: stop recording
 * and keep it stopped for the rest of the page's life.
 */
export function stopLogRocketForInternalUser(email) {
  if (!isInternalEmail(email)) return false;

  blocked = true;

  if (recording) {
    recording = false;
    if (typeof LogRocket.uninstall === 'function') LogRocket.uninstall();
  }

  return true;
}

export function identifyInLogRocket(userId, traits) {
  if (!recording) return;

  LogRocket.identify(userId, traits);
}
